import Joi from 'joi-browser';

const validationSchema = {
  name: Joi.string()
    .label('Nombre')
    .max(255)
    .required(),
  description: Joi.string()
    .label('Descripción')
    .required(),
  containers: Joi.number()
    .label('Containers')
    .integer()
    .positive(),
  year: Joi.number()
    .label('Año de publicación')
    .integer()
    .positive(),
  rights: Joi.string()
    .label('Derechos o Royalties'),
  theater: Joi.object()
    .keys({
      name: Joi.string().required(),
    }),
  type: Joi.string(),
  salerent: Joi.string(),
  budget: Joi.string(),

  regisseur: Joi.string()
    .allow([null, ''])
    .optional(),
  scenographer: Joi.string()
    .allow([null, ''])
    .optional(),
  dressmaker: Joi.string()
    .allow([null, ''])
    .optional(),
  illuminator: Joi.string()
    .allow([null, ''])
    .optional(),
  multimedia: Joi.string()
    .allow([null, ''])
    .optional(),
  stagecraft: Joi.string()
    .allow([null, ''])
    .optional(),

  sets: Joi.string()
    .allow([null, ''])
    .optional(),
  costumes: Joi.string()
    .allow([null, ''])
    .optional(),
  titles: Joi.string()
    .allow([null, ''])
    .optional(),
  props: Joi.string()
    .allow([null, ''])
    .optional(),
  orchestration: Joi.string()
    .allow([null, ''])
    .optional(),

  childProductions: Joi.boolean(),
  adultProductions: Joi.boolean(),
  cast: Joi.boolean(),

  video1: Joi.string()
    .label('Primer Video')
    .allow([null, ''])
    .uri({
      scheme: ['http', 'https'],
    }),

  video2: Joi.string()
    .label('Segundo Video')
    .allow([null, ''])
    .uri({
      scheme: ['http', 'https'],
    }),

  files: Joi.array()
    .label('Archivos')
    .optional(),
  images: Joi.array()
    .label('Imágenes')
    .max(8)
    .min(1)
    .error(() => ({
      type: 'array.min',
      message: 'Debes subir al menos una imagen para esta producción',
    })),
};

export default validationSchema;



// WEBPACK FOOTER //
// ./src/containers/Admin/Production/Form/validation.js